(() => {
  if (customElements.get('product-form')) return;
  const deliveryUrl = new URL('restaria-cart-delivery.js', document.currentScript.src).href;
  let loadingDelivery;
  const loadDelivery = () => {
    if (window.RestaCartDelivery) return Promise.resolve();
    if (!loadingDelivery)
      loadingDelivery = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = deliveryUrl;
        script.async = true;
        script.onload = () =>
          window.RestaCartDelivery ? resolve() : reject(Error('Carrello non disponibile. Ricarica la pagina.'));
        script.onerror = () => reject(Error('Carrello non disponibile. Ricarica la pagina.'));
        document.head.append(script);
      }).catch((error) => {
        loadingDelivery = null;
        throw error;
      });
    return loadingDelivery;
  };
  loadDelivery().catch(() => {});
  customElements.define(
    'product-form',
    class extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');
        this.submitButton.setAttribute('aria-haspopup', 'dialog');
        this.hideErrors = this.dataset.hideErrors === 'true';
      }
      async onSubmitHandler(event) {
        event.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true' || this.form.dataset.restaCartPending === 'true')
          return;
        if (!this.form.reportValidity()) return;
        this.handleErrorMessage();
        this.error = false;
        this.submitButton.setAttribute('aria-disabled', 'true');
        this.submitButton.classList.add('loading');
        const spinner = this.querySelector('.loading__spinner');
        spinner?.classList.remove('hidden');
        this.form.setAttribute('aria-busy', 'true');
        let status = this.form.querySelector('[data-resta-cart-status]');
        if (!status) {
          status = document.createElement('p');
          status.dataset.restaCartStatus = '';
          status.setAttribute('role', 'status');
          status.style.cssText = 'margin:8px 0;font-size:12px;line-height:1.4;text-align:center;';
          this.submitButton.insertAdjacentElement('afterend', status);
        }
        status.hidden = false;
        status.textContent = 'Preparazione del tuo gioiello…';
        const started = performance.now();
        try {
          const id = this.form.getAttribute('id');
          const [personalizedPreview, necklacePreview] = await Promise.all([
            window.RestaPersonalizationExporters?.[id]?.(this.form) || null,
            window.RestaNecklaceExporters?.[id]?.(this.form) || null,
            loadDelivery(),
          ]);
          const formData = new FormData(this.form);
          if (personalizedPreview) {
            formData.set(
              'properties[Anteprima personalizzazione]',
              personalizedPreview.uploadBlob || personalizedPreview.blob,
              personalizedPreview.uploadFilename || personalizedPreview.filename,
            );
            (personalizedPreview.files || []).forEach((file) =>
              formData.set('properties[' + file.propertyName + ']', file.blob, file.filename),
            );
            Object.entries(personalizedPreview.properties || {}).forEach(([name, value]) =>
              formData.set('properties[' + name + ']', value),
            );
          }
          if (necklacePreview)
            formData.set(
              'properties[' + (necklacePreview.propertyName || 'Anteprima collana') + ']',
              necklacePreview.blob,
              necklacePreview.filename,
            );
          this.form.dataset.restaCartPreparationMs = String(Math.round(performance.now() - started));
          status.textContent = 'Aggiunta al carrello…';
          const quickAddModal = this.closest('quick-add-modal');
          const beforeOpen = quickAddModal
            ? () =>
                new Promise((resolve) => {
                  let timer;
                  const done = () => {
                    clearTimeout(timer);
                    document.body.removeEventListener('modalClosed', done);
                    resolve();
                  };
                  document.body.addEventListener('modalClosed', done, { once: true });
                  timer = setTimeout(done, 400);
                  quickAddModal.hide(true);
                })
            : null;
          await window.RestaCartDelivery(formData, this.form, beforeOpen);
          this.form.dataset.restaCartTotalMs = String(Math.round(performance.now() - started));
        } catch (error) {
          console.error('RESTA: aggiunta al carrello non riuscita.', error);
          this.handleErrorMessage(error.message || 'Non è stato possibile aggiungere il gioiello. Riprova.');
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined')
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: this.variantIdInput.value,
              message: error.message,
            });
        } finally {
          this.submitButton.classList.remove('loading');
          this.submitButton.removeAttribute('aria-disabled');
          spinner?.classList.add('hidden');
          this.form.removeAttribute('aria-busy');
          status.hidden = true;
          status.textContent = '';
        }
      }
      handleErrorMessage(message = false) {
        if (this.hideErrors) return;
        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
        this.errorMessageWrapper.toggleAttribute('hidden', !message);
        if (message) this.errorMessage.textContent = message;
      }
      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text && this.submitButtonText) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          if (this.submitButtonText) this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }
      get variantIdInput() {
        return this.form.querySelector('[name="id"]');
      }
    },
  );
})();
